// Department data for YK-USA Coordination Team
// Each department has: id, slug, name, coordinator, type, description, icon (FA class), color, gradient
// Plus detail fields: about, activities, schedule, location, contact, teamMembers, highlights

const DepartmentsData = [
  {
    id: 1,
    slug: "montessori-school",
    name: "Montessori School",
    coordinator: "Priyabrata B",
    type: "Public Facing",
    description: "Early childhood education program following Montessori principles",
    icon: "fa-graduation-cap",
    color: "#6366F1",
    gradient: "linear-gradient(135deg, #6366F1, #8B5CF6)",
    about: "Our Montessori School provides a nurturing environment for children ages 3-6, following the time-tested Montessori method. We focus on hands-on learning, self-paced curriculum, and building a strong foundation for lifelong education. Our certified teachers guide children through practical life skills, sensorial exploration, language, mathematics, and cultural studies.",
    activities: ["Montessori Curriculum (Ages 3-6)", "Practical Life Skills Training", "Sensorial & Math Activities", "Language & Cultural Studies", "Parent-Teacher Conferences", "Annual Graduation Ceremony"],
    schedule: "Monday - Friday, 9:00 AM - 2:00 PM",
    location: "Yugal Kunj Building A, Room 101-104",
    contact: { email: "montessori@yugalkunj.org", phone: "(678) 920-6669 ext. 101" },
    teamMembers: ["Priyabrata B (Lead)", "Anita S (Teacher)", "Meera K (Assistant)"],
    highlights: [
      { label: "Students Enrolled", value: "45+" },
      { label: "Certified Teachers", value: "4" },
      { label: "Years Running", value: "8+" },
      { label: "Parent Satisfaction", value: "98%" }
    ]
  },
  {
    id: 2,
    slug: "satsang-music",
    name: "Satsang Music",
    coordinator: "Richa S",
    type: "Public Facing",
    description: "Devotional music and kirtan programs",
    icon: "fa-music",
    color: "#EC4899",
    gradient: "linear-gradient(135deg, #EC4899, #F43F5E)",
    about: "The Satsang Music department brings the community together through the power of devotional music. We organize weekly bhajan sessions, kirtan programs, and music classes for all ages. Our mission is to preserve and promote traditional devotional music while making it accessible to the younger generation.",
    activities: ["Weekly Bhajan & Kirtan Sessions", "Harmonium & Tabla Classes", "Vocal Training for Devotional Singing", "Festival Music Performances", "Children's Music Workshop", "Annual Music Concert"],
    schedule: "Every Saturday, 6:00 PM - 8:00 PM",
    location: "Yugal Kunj Main Hall",
    contact: { email: "music@yugalkunj.org", phone: "(678) 920-6669 ext. 102" },
    teamMembers: ["Richa S (Lead)", "Suresh M (Tabla)", "Kavita R (Harmonium)"],
    highlights: [
      { label: "Weekly Sessions", value: "3" },
      { label: "Music Students", value: "30+" },
      { label: "Instruments", value: "12" },
      { label: "Performances/Year", value: "20+" }
    ]
  },
  {
    id: 3,
    slug: "yk-operation",
    name: "YK Operation",
    coordinator: "Raj R",
    type: "Private",
    description: "Internal operations and management",
    icon: "fa-cogs",
    color: "#64748B",
    gradient: "linear-gradient(135deg, #64748B, #475569)",
    about: "YK Operations manages the day-to-day functioning of the temple and community center. From scheduling and logistics to vendor management and compliance, this department ensures smooth operations across all other departments. We coordinate resources, manage facilities, and maintain operational standards.",
    activities: ["Daily Operations Management", "Facility Scheduling & Booking", "Vendor & Supply Chain Management", "Compliance & Safety Oversight", "Inter-Department Coordination", "Emergency Response Planning"],
    schedule: "Daily Operations, 8:00 AM - 9:00 PM",
    location: "Yugal Kunj Administrative Office",
    contact: { email: "operations@yugalkunj.org", phone: "(678) 920-6669 ext. 100" },
    teamMembers: ["Raj R (Lead)", "Vikram P (Ops Manager)", "Neha T (Coordinator)"],
    highlights: [
      { label: "Events Managed/Year", value: "150+" },
      { label: "Facility Uptime", value: "99%" },
      { label: "Team Members", value: "6" },
      { label: "Vendors Managed", value: "25+" }
    ]
  },
  {
    id: 4,
    slug: "finance-accounting",
    name: "Finance Accounting",
    coordinator: "Kamlesh N",
    type: "Private",
    description: "Financial management and accounting services",
    icon: "fa-dollar-sign",
    color: "#10B981",
    gradient: "linear-gradient(135deg, #10B981, #14B8A6)",
    about: "The Finance & Accounting department manages all financial aspects of Yugal Kunj, including budgeting, bookkeeping, donation tracking, tax compliance, and financial reporting. We ensure full transparency and accountability in the use of community funds and donations.",
    activities: ["Annual Budget Planning", "Donation Tracking & Receipts", "Tax Filing & Compliance", "Monthly Financial Reporting", "Expense Management", "Audit Preparation"],
    schedule: "Monday - Friday, 10:00 AM - 4:00 PM",
    location: "Yugal Kunj Administrative Office",
    contact: { email: "finance@yugalkunj.org", phone: "(678) 920-6669 ext. 105" },
    teamMembers: ["Kamlesh N (Lead)", "Priya D (Accountant)", "Rohit S (Treasurer)"],
    highlights: [
      { label: "Annual Budget", value: "$500K+" },
      { label: "Donors Managed", value: "800+" },
      { label: "Tax Receipts Issued", value: "1000+" },
      { label: "Transparency Score", value: "100%" }
    ]
  },
  {
    id: 5,
    slug: "public-relation",
    name: "Public Relation",
    coordinator: "Shyam G",
    type: "Public Facing",
    description: "Community outreach and public relations",
    icon: "fa-users",
    color: "#0EA5E9",
    gradient: "linear-gradient(135deg, #0EA5E9, #3B82F6)",
    about: "The Public Relations department serves as the bridge between Yugal Kunj and the broader community. We manage media relations, community partnerships, outreach programs, and public communications. Our goal is to build strong relationships and increase awareness of our programs and services.",
    activities: ["Community Outreach Programs", "Media Relations & Press Releases", "Partnership Development", "Newsletter & Communications", "Welcome Committee for New Members", "Inter-Faith Dialogue Events"],
    schedule: "Flexible - Event-Based",
    location: "Yugal Kunj Community Hall",
    contact: { email: "pr@yugalkunj.org", phone: "(678) 920-6669 ext. 106" },
    teamMembers: ["Shyam G (Lead)", "Anita K (Outreach)", "Deepak M (Media)"],
    highlights: [
      { label: "Community Partners", value: "15+" },
      { label: "Events Promoted", value: "50+/yr" },
      { label: "Newsletter Subscribers", value: "2000+" },
      { label: "New Members/Year", value: "100+" }
    ]
  },
  {
    id: 6,
    slug: "rentals",
    name: "Rentals",
    coordinator: "Harsha R",
    type: "Public Facing",
    description: "Facility rental and booking services",
    icon: "fa-home",
    color: "#F59E0B",
    gradient: "linear-gradient(135deg, #F59E0B, #F97316)",
    about: "Our Rentals department manages the booking of Yugal Kunj's beautiful facilities for community events, weddings, corporate meetings, and cultural programs. We offer well-maintained halls, outdoor spaces, and full-service support for your events.",
    activities: ["Hall Rental & Booking Management", "Wedding & Reception Hosting", "Corporate Meeting Rooms", "Outdoor Space Rentals", "Catering Coordination", "Event Setup & Cleanup Support"],
    schedule: "Available 7 Days a Week, 8:00 AM - 10:00 PM",
    location: "Yugal Kunj Main Hall & Banquet",
    contact: { email: "rentals@yugalkunj.org", phone: "(678) 920-6669 ext. 107" },
    teamMembers: ["Harsha R (Lead)", "Amit S (Booking Manager)", "Priya L (Event Coordinator)"],
    highlights: [
      { label: "Events Hosted/Year", value: "80+" },
      { label: "Capacity (Main Hall)", value: "500" },
      { label: "Outdoor Space", value: "2 Acres" },
      { label: "Client Satisfaction", value: "95%" }
    ]
  },
  {
    id: 7,
    slug: "recreational-sports",
    name: "Recreational Sports",
    coordinator: "Asutosh P",
    type: "Public Facing",
    description: "Sports activities and recreational programs",
    icon: "fa-trophy",
    color: "#EAB308",
    gradient: "linear-gradient(135deg, #EAB308, #F59E0B)",
    about: "The Recreational Sports department promotes physical fitness and community bonding through organized sports activities. We offer cricket, badminton, volleyball, yoga, and seasonal tournaments. Our programs cater to all ages, from children to seniors.",
    activities: ["Weekend Cricket Matches", "Badminton & Volleyball Leagues", "Yoga & Fitness Classes", "Annual Sports Tournament", "Children's Sports Camp", "Walking & Running Club"],
    schedule: "Weekends, 7:00 AM - 12:00 PM",
    location: "Yugal Kunj Sports Field & Indoor Court",
    contact: { email: "sports@yugalkunj.org", phone: "(678) 920-6669 ext. 108" },
    teamMembers: ["Asutosh P (Lead)", "Ravi K (Cricket Coach)", "Sunita M (Yoga Instructor)"],
    highlights: [
      { label: "Active Players", value: "120+" },
      { label: "Sports Offered", value: "6" },
      { label: "Tournaments/Year", value: "4" },
      { label: "Age Groups", value: "All Ages" }
    ]
  },
  {
    id: 8,
    slug: "project-mgmt",
    name: "Project Mgmt",
    coordinator: "Dhruti R",
    type: "Private",
    description: "Project planning and management",
    icon: "fa-clipboard-list",
    color: "#8B5CF6",
    gradient: "linear-gradient(135deg, #8B5CF6, #D946EF)",
    about: "The Project Management department oversees all major initiatives, construction projects, and strategic improvements at Yugal Kunj. We use modern project management methodologies to ensure timely delivery, budget adherence, and quality outcomes for every project.",
    activities: ["Construction & Renovation Projects", "Strategic Planning & Roadmaps", "Budget & Timeline Tracking", "Contractor & Vendor Coordination", "Progress Reporting", "Risk Management"],
    schedule: "Monday - Friday, 10:00 AM - 5:00 PM",
    location: "Yugal Kunj Administrative Office",
    contact: { email: "projects@yugalkunj.org", phone: "(678) 920-6669 ext. 109" },
    teamMembers: ["Dhruti R (Lead)", "Sanjay P (Project Coordinator)", "Meera J (Planner)"],
    highlights: [
      { label: "Active Projects", value: "5" },
      { label: "Completed Projects", value: "25+" },
      { label: "On-Time Delivery", value: "92%" },
      { label: "Budget Adherence", value: "95%" }
    ]
  },
  {
    id: 9,
    slug: "hyc-non-religious-programs",
    name: "HYC Non Religious Programs",
    coordinator: "Abhisek D",
    type: "Public Facing",
    description: "Hindu Youth Camp non-religious activities",
    icon: "fa-star",
    color: "#06B6D4",
    gradient: "linear-gradient(135deg, #06B6D4, #3B82F6)",
    about: "The HYC Non-Religious Programs department organizes fun, educational, and skill-building activities for the Hindu Youth Camp. These programs complement spiritual education with practical life skills, leadership training, arts, and recreational activities designed for youth ages 8-18.",
    activities: ["Leadership & Public Speaking Workshops", "Arts & Crafts Sessions", "Science & Technology Workshops", "Community Service Projects", "Team Building Activities", "Career Guidance Seminars"],
    schedule: "During HYC Sessions & Monthly Workshops",
    location: "Yugal Kunj Youth Center",
    contact: { email: "hyc@yugalkunj.org", phone: "(678) 920-6669 ext. 110" },
    teamMembers: ["Abhisek D (Lead)", "Neha R (Workshop Coordinator)", "Vikram S (Mentor)"],
    highlights: [
      { label: "Youth Participants", value: "80+" },
      { label: "Programs Offered", value: "12" },
      { label: "Workshops/Year", value: "24" },
      { label: "Age Range", value: "8-18" }
    ]
  },
  {
    id: 10,
    slug: "shringar",
    name: "Shringar",
    coordinator: "Dhruti R",
    type: "Public Facing",
    description: "Temple decoration and beautification",
    icon: "fa-spa",
    color: "#F43F5E",
    gradient: "linear-gradient(135deg, #F43F5E, #EC4899)",
    about: "The Shringar department is responsible for the daily and festive decoration of the temple deities. Our team creates beautiful floral arrangements, dresses the deities in traditional attire, and ensures the sanctum looks resplendent for every occasion.",
    activities: ["Daily Deity Decoration", "Festival Special Shringar", "Floral Arrangement Design", "Traditional Attire Coordination", "Seasonal Theme Decorations", "Special Occasion Setups"],
    schedule: "Daily, 6:00 AM - 8:00 AM & Festival Days",
    location: "Yugal Kunj Temple Sanctum",
    contact: { email: "shringar@yugalkunj.org", phone: "(678) 920-6669 ext. 111" },
    teamMembers: ["Dhruti R (Lead)", "Asha P (Floral Designer)", "Kavita M (Attire Coordinator)"],
    highlights: [
      { label: "Daily Decorations", value: "365/yr" },
      { label: "Festival Themes", value: "15+" },
      { label: "Volunteers", value: "10+" },
      { label: "Flower Varieties Used", value: "25+" }
    ]
  },
  {
    id: 11,
    slug: "kitchen",
    name: "Kitchen",
    coordinator: "Vaishali B",
    type: "Public Facing",
    description: "Food preparation and prasad services",
    icon: "fa-utensils",
    color: "#F97316",
    gradient: "linear-gradient(135deg, #F97316, #EF4444)",
    about: "The Kitchen department prepares delicious vegetarian prasad and meals for all temple events, festivals, and community gatherings. Our team of dedicated volunteers follows strict hygiene standards and traditional recipes to serve wholesome, sattvic food to hundreds of devotees every week.",
    activities: ["Daily Prasad Preparation", "Festival Feast Cooking", "Sunday Community Lunch", "Cooking Classes & Workshops", "Catering for Rentals", "Food Hygiene & Safety Compliance"],
    schedule: "Daily, 7:00 AM - 2:00 PM & Event Days",
    location: "Yugal Kunj Kitchen & Dining Hall",
    contact: { email: "kitchen@yugalkunj.org", phone: "(678) 920-6669 ext. 112" },
    teamMembers: ["Vaishali B (Lead)", "Sunita K (Head Cook)", "Ramesh P (Supplies)"],
    highlights: [
      { label: "Meals Served/Week", value: "500+" },
      { label: "Kitchen Volunteers", value: "20+" },
      { label: "Menu Items", value: "50+" },
      { label: "Events Catered/Year", value: "60+" }
    ]
  },
  {
    id: 12,
    slug: "gurukul",
    name: "Gurukul",
    coordinator: "Anoop D",
    type: "Public Facing",
    description: "Traditional spiritual education programs",
    icon: "fa-book-open",
    color: "#D946EF",
    gradient: "linear-gradient(135deg, #D946EF, #8B5CF6)",
    about: "The Gurukul department provides traditional spiritual and cultural education to children and adults. Our curriculum includes Sanskrit shlokas, Bhagavad Gita studies, Indian history, Hindi language, and cultural values.",
    activities: ["Sanskrit & Shloka Classes", "Bhagavad Gita Study Groups", "Hindi Language Classes", "Indian History & Culture", "Storytelling Sessions (Mythology)", "Annual Cultural Showcase"],
    schedule: "Sundays, 10:00 AM - 12:30 PM",
    location: "Yugal Kunj Classrooms",
    contact: { email: "gurukul@yugalkunj.org", phone: "(678) 920-6669 ext. 113" },
    teamMembers: ["Anoop D (Lead)", "Radhika S (Sanskrit Teacher)", "Vinod K (Hindi Teacher)"],
    highlights: [
      { label: "Students", value: "60+" },
      { label: "Courses Offered", value: "8" },
      { label: "Teachers", value: "6" },
      { label: "Years Active", value: "10+" }
    ]
  },
  {
    id: 13,
    slug: "audio-visual",
    name: "Audio Visual",
    coordinator: "Hiren K",
    type: "Public Facing",
    description: "AV equipment and multimedia services",
    icon: "fa-video",
    color: "#3B82F6",
    gradient: "linear-gradient(135deg, #3B82F6, #6366F1)",
    about: "The Audio Visual department manages all sound, lighting, and video equipment for temple events, live streaming, and recordings. We ensure high-quality AV support for every program.",
    activities: ["Live Streaming of Events", "Sound System Management", "Video Recording & Editing", "Lighting Design for Events", "Equipment Maintenance", "Photography Services"],
    schedule: "All Event Days & Sundays",
    location: "Yugal Kunj AV Control Room",
    contact: { email: "av@yugalkunj.org", phone: "(678) 920-6669 ext. 114" },
    teamMembers: ["Hiren K (Lead)", "Sachin M (Sound Engineer)", "Pooja R (Video Editor)"],
    highlights: [
      { label: "Events Streamed/Year", value: "100+" },
      { label: "YouTube Subscribers", value: "5K+" },
      { label: "Equipment Value", value: "$50K+" },
      { label: "Team Members", value: "5" }
    ]
  },
  {
    id: 14,
    slug: "fundraising",
    name: "Fundraising",
    coordinator: "Kishore M",
    type: "Public Facing",
    description: "Donations and fundraising initiatives",
    icon: "fa-heart",
    color: "#EF4444",
    gradient: "linear-gradient(135deg, #EF4444, #EC4899)",
    about: "The Fundraising department leads all donation drives, capital campaigns, and sponsorship programs for Yugal Kunj. We organize creative fundraising events, manage donor relationships, and ensure that every contribution is used effectively.",
    activities: ["Annual Fundraising Gala", "Capital Campaign Management", "Donor Recognition Programs", "Online Donation Platform", "Sponsorship Development", "Grant Writing & Applications"],
    schedule: "Ongoing - Events Throughout the Year",
    location: "Yugal Kunj Community Hall",
    contact: { email: "donate@yugalkunj.org", phone: "(678) 920-6669 ext. 115" },
    teamMembers: ["Kishore M (Lead)", "Anita P (Donor Relations)", "Suresh K (Events)"],
    highlights: [
      { label: "Funds Raised/Year", value: "$200K+" },
      { label: "Active Donors", value: "500+" },
      { label: "Fundraising Events", value: "8/yr" },
      { label: "Recurring Donors", value: "150+" }
    ]
  },
  {
    id: 15,
    slug: "gardening",
    name: "Gardening",
    coordinator: "Bharti J",
    type: "Public Facing",
    description: "Landscape maintenance and gardening",
    icon: "fa-leaf",
    color: "#22C55E",
    gradient: "linear-gradient(135deg, #22C55E, #10B981)",
    about: "The Gardening department maintains the beautiful landscapes, flower gardens, and green spaces around Yugal Kunj. Our team of passionate volunteers ensures the grounds are always pristine, with seasonal plantings, organic vegetable gardens, and eco-friendly practices.",
    activities: ["Landscape Design & Maintenance", "Seasonal Flower Planting", "Organic Vegetable Garden", "Tree Care & Pruning", "Irrigation System Management", "Community Garden Days"],
    schedule: "Saturdays, 8:00 AM - 12:00 PM",
    location: "Yugal Kunj Grounds & Gardens",
    contact: { email: "garden@yugalkunj.org", phone: "(678) 920-6669 ext. 116" },
    teamMembers: ["Bharti J (Lead)", "Ramesh N (Landscaper)", "Priya T (Organic Garden)"],
    highlights: [
      { label: "Garden Area", value: "3 Acres" },
      { label: "Plant Varieties", value: "100+" },
      { label: "Volunteers", value: "15+" },
      { label: "Produce Harvested/Year", value: "500 lbs" }
    ]
  },
  {
    id: 16,
    slug: "maintenance",
    name: "Maintenance",
    coordinator: "Ram A",
    type: "Private",
    description: "Facility maintenance and repairs",
    icon: "fa-wrench",
    color: "#78716C",
    gradient: "linear-gradient(135deg, #78716C, #57534E)",
    about: "The Maintenance department ensures that all buildings, systems, and infrastructure at Yugal Kunj are in excellent condition. From plumbing and electrical work to HVAC and structural repairs, our team handles it all.",
    activities: ["Preventive Maintenance Schedules", "Plumbing & Electrical Repairs", "HVAC System Management", "Building Inspections", "Safety Equipment Checks", "Emergency Repairs"],
    schedule: "Daily On-Call, 7:00 AM - 7:00 PM",
    location: "Yugal Kunj Maintenance Workshop",
    contact: { email: "maintenance@yugalkunj.org", phone: "(678) 920-6669 ext. 117" },
    teamMembers: ["Ram A (Lead)", "Sunil T (Electrician)", "Manoj K (Plumber)"],
    highlights: [
      { label: "Building Sq Ft", value: "25,000+" },
      { label: "Repairs/Month", value: "30+" },
      { label: "Uptime", value: "99%" },
      { label: "Response Time", value: "<2 hrs" }
    ]
  },
  {
    id: 17,
    slug: "decorations",
    name: "Decorations",
    coordinator: "Namrata K",
    type: "Public Facing",
    description: "Event decoration and design services",
    icon: "fa-palette",
    color: "#A855F7",
    gradient: "linear-gradient(135deg, #A855F7, #EC4899)",
    about: "The Decorations department transforms spaces into stunning visual experiences for festivals, celebrations, and special events. From traditional rangoli and floral mandaps to modern stage designs, our creative team brings every event to life.",
    activities: ["Festival Decoration Design", "Stage & Mandap Setup", "Rangoli & Floor Art", "Balloon & Theme Decorations", "Lighting Design", "Table & Venue Styling"],
    schedule: "Event-Based - Weekends & Festivals",
    location: "Yugal Kunj All Venues",
    contact: { email: "decor@yugalkunj.org", phone: "(678) 920-6669 ext. 118" },
    teamMembers: ["Namrata K (Lead)", "Seema R (Floral Designer)", "Rekha P (Stage Design)"],
    highlights: [
      { label: "Events Decorated/Year", value: "40+" },
      { label: "Design Themes", value: "20+" },
      { label: "Creative Team", value: "8" },
      { label: "Client Rating", value: "4.9/5" }
    ]
  },
  {
    id: 18,
    slug: "info-tech",
    name: "Info Tech (IT)",
    coordinator: "Manish S",
    type: "Private",
    description: "Technology infrastructure and support",
    icon: "fa-laptop-code",
    color: "#14B8A6",
    gradient: "linear-gradient(135deg, #06B6D4, #14B8A6)",
    about: "The IT department manages all technology infrastructure including the website, network systems, databases, email services, and security systems. We also develop and maintain custom applications for temple management, event registration, and community engagement.",
    activities: ["Website Development & Maintenance", "Network & Wi-Fi Management", "Security Camera Systems", "Custom Application Development", "Email & Communication Systems", "Technical Support & Helpdesk"],
    schedule: "On-Call Support - 7 Days a Week",
    location: "Yugal Kunj Server Room & Remote",
    contact: { email: "it@yugalkunj.org", phone: "(678) 920-6669 ext. 119" },
    teamMembers: ["Manish S (Lead)", "Ravi K (Developer)", "Amit P (Network Admin)"],
    highlights: [
      { label: "Systems Managed", value: "15+" },
      { label: "Uptime", value: "99.9%" },
      { label: "Apps Developed", value: "5" },
      { label: "Support Tickets/Month", value: "20+" }
    ]
  },
  {
    id: 19,
    slug: "social-media",
    name: "Social Media",
    coordinator: "Riya G",
    type: "Private",
    description: "Digital presence and social media management",
    icon: "fa-share-alt",
    color: "#EC4899",
    gradient: "linear-gradient(135deg, #EC4899, #D946EF)",
    about: "The Social Media department manages Yugal Kunj's digital presence across all major platforms including Facebook, Instagram, YouTube, and WhatsApp. We create engaging content, promote events, share spiritual teachings, and build an online community of devotees worldwide.",
    activities: ["Content Creation & Scheduling", "Event Promotion & Marketing", "Photography & Videography", "Community Engagement Online", "Analytics & Growth Strategy", "WhatsApp Group Management"],
    schedule: "Daily Content Management",
    location: "Remote & On-Site",
    contact: { email: "social@yugalkunj.org", phone: "(678) 920-6669 ext. 120" },
    teamMembers: ["Riya G (Lead)", "Neha M (Content Creator)", "Arjun S (Photographer)"],
    highlights: [
      { label: "Social Followers", value: "10K+" },
      { label: "Posts/Month", value: "60+" },
      { label: "Engagement Rate", value: "8%+" },
      { label: "Platforms Managed", value: "5" }
    ]
  },
  {
    id: 20,
    slug: "youth-engagement",
    name: "Youth Engagement",
    coordinator: "Sunil P",
    type: "Public Facing",
    description: "Youth programs and community engagement",
    icon: "fa-user-friends",
    color: "#6366F1",
    gradient: "linear-gradient(135deg, #6366F1, #3B82F6)",
    about: "The Youth Engagement department focuses on connecting young people (ages 13-30) with the temple community through meaningful programs, mentorship, social events, and leadership opportunities. We aim to create a vibrant youth community that is both spiritually grounded and socially conscious.",
    activities: ["Youth Leadership Program", "College Student Meetups", "Career Mentorship", "Social Service Projects", "Youth Retreats & Camps", "Cultural Performance Groups"],
    schedule: "Bi-Weekly Sundays, 4:00 PM - 6:00 PM",
    location: "Yugal Kunj Youth Center",
    contact: { email: "youth@yugalkunj.org", phone: "(678) 920-6669 ext. 121" },
    teamMembers: ["Sunil P (Lead)", "Priya R (Mentor Coordinator)", "Karan D (Events)"],
    highlights: [
      { label: "Active Youth Members", value: "100+" },
      { label: "Mentors", value: "15" },
      { label: "Events/Year", value: "20+" },
      { label: "College Partnerships", value: "5" }
    ]
  }
];

// Helper to find department by slug
export const getDepartmentBySlug = (slug) =>
  DepartmentsData.find((d) => d.slug === slug);

// Helper to find department by id
export const getDepartmentById = (id) =>
  DepartmentsData.find((d) => d.id === id);

export default DepartmentsData;
